// extracted by mini-css-extract-plugin
export default {"submenuContentWrapper":"SubmenuIconWrapper-IbqSm__submenuContentWrapper","listContent":"SubmenuIconWrapper--ufbg__listContent","listItem":"SubmenuIconWrapper-weE0q__listItem"};